export enum PricingRowActionType {
  SEE_PRICING_DETAIL = 'SEE_PRICING_DETAIL',
  REMOVE_PRICING_FROM_AGENT = 'REMOVE_PRICING_FROM_AGENT',
}
